module.exports = __webpack_public_path__ + "static/media/orange.adf58255.png";